import { DateTime } from 'luxon';
import { StorageUtil } from '../../../shared/utils/storage';
import { getUserEmail } from '../../../shared/utils/user-details';
import { getUserEmailFromStore } from '../../home/utils/helper';
import { TableColumnsKey } from '../enums/reports';

export const getSequenceReportCellData = (value) => {
  if (value && typeof value !== 'object') {
    return value;
  }
  return 0;
};
export const getSequenceReportCellDataWithPercentage = (value) => {
  if (value && typeof value !== 'object') {
    return `(${value}%)`;
  }
  return '(0%)';
};

export const getSequenceReportCellDataWithDealValue = (
  value,
  showZeroDealValue = false,
) => {
  if (value && typeof value !== 'object') {
    return `$${value}`;
  }
  if (Number(value) === 0 && showZeroDealValue) {
    return `$0`;
  }
  return '';
};

export const getSelectedColumns = (key: string) =>
  JSON.parse(StorageUtil.getItem(key));

export const setSelectedColumns = (key: string, cols: number[]) =>
  StorageUtil.setItem(key, JSON.stringify(cols));

const sequenceReportsFilter = 'sequence-reports-filter';
const teamPerformanceFilters = 'team-performance-filters';
const emailReportsFilter = 'email-reports-filter';

export const getSequenceReportsFilters = () => {
  const filters = StorageUtil.getItem(sequenceReportsFilter);

  if (filters) {
    const userEmail = getUserEmail();
    const userEmailFromLS = getUserEmailFromStore();

    if (userEmailFromLS === userEmail) {
      return JSON.parse(filters);
    }
  }

  return null;
};
export const setSequenceReportsFiltersToLocalStore = (filters) =>
  StorageUtil.setItem(sequenceReportsFilter, JSON.stringify(filters));

export const removeSequenceReportsFilters = () =>
  StorageUtil.removeItem(sequenceReportsFilter);

export const getTeamPerformanceFilters = () => {
  const filters = StorageUtil.getItem(teamPerformanceFilters);

  if (filters) {
    return JSON.parse(filters);
  }

  return null;
};

export const setTeamPerformanceFilters = (filters) =>
  StorageUtil.setItem(teamPerformanceFilters, JSON.stringify(filters));

export const removeTeamPerformanceFilters = () =>
  StorageUtil.removeItem(teamPerformanceFilters);

// Email Reports Filters
export const getEmailReportsFilters = () => {
  const filters = StorageUtil.getItem(emailReportsFilter);

  if (filters) {
    const userEmail = getUserEmail();
    const userEmailFromLS = getUserEmailFromStore();

    if (userEmailFromLS === userEmail) {
      return JSON.parse(filters);
    }
  }

  return null;
};

export const setEmailReportsFiltersToLocalStore = (filters) =>
  StorageUtil.setItem(emailReportsFilter, JSON.stringify(filters));

export const removeEmailReportsFilters = () =>
  StorageUtil.removeItem(emailReportsFilter);

export const removeSelectedColumnsFromLocalStorage = () => {
  StorageUtil.removeItem(TableColumnsKey.SequenceProspectCols);
  StorageUtil.removeItem(TableColumnsKey.TeamProspectCols);
  StorageUtil.removeItem(TableColumnsKey.EmailReportColsByProspects);
  StorageUtil.removeItem(TableColumnsKey.EmailReportColsByEmail);
};

export const convertDate = (
  date: DateTime,
  fromZone: string,
  toZone: string,
) => {
  if (!date) return date;
  const browserDate = DateTime.fromJSDate(date.toJSDate(), {
    zone: fromZone,
  }).startOf('day');
  const userDate = browserDate
    .setZone(toZone, { keepLocalTime: true })
    .startOf('day');

  const browserOffset = browserDate.offset;
  const userOffset = userDate.offset;
  const offsetDifference = userOffset - browserOffset;

  let adjustedDate = browserDate;
  if (offsetDifference < 0) {
    adjustedDate = browserDate.plus({ minutes: -offsetDifference });
  }

  return adjustedDate.setZone(toZone);
};
